import React from "react"
import Pic from "./image"

const Hero = () => (
  <div className="flex flex-wrap flex-col lg:flex-row">
    <div
      className="w-full lg:w-1/2 p-4 lg:p-12"
      data-sal="slide-up"
      data-sal-delay="300"
      data-sal-easing="ease"
    >
      <h1>Developing Future Champions</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vitae eros
        tempus dolor pharetra placerat eget non eros. Morbi porta nibh at
        bibendum mattis. In blandit nisi ut posuere fermentum. Nullam faucibus
        ex sit amet risus mollis gravida. Mauris vel ligula luctus, suscipit
        purus ut, varius nisi. Curabitur et dui ac sem fringilla lobortis.
        Aliquam vel rhoncus odio, commodo laoreet tortor. Nam lobortis mattis ex
        ut dignissim. Ut fermentum nisl id nulla consequat, ut aliquam arcu
        ornare.
      </p>
      <button class="btn btn-dark">Learn More</button>
    </div>
    <div className="w-full lg:w-1/2">
      <Pic filename="test-image.jpg" />
    </div>
    <div className="w-full relative h-screen overflow-hidden">
      <Pic filename="kober-calgary.jpg" />
      <div className="panel-content bg-gray-700 bg-opacity-50">
        <div data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
          <h4>
            Athlete Centered,
            <br />
            Coach Delivered
          </h4>
          <a href="/athletes">
            <button className="btn btn-dark">LTAD Stages</button>
          </a>
        </div>
      </div>
    </div>
  </div> //End Main DIV
)

export default Hero
